module.exports = _.invert;